<template>
    <div>
        <div class="button-navigation hide-scrollbar">
                <button class="btn" :class="[navMove === index ? 'active-navigation' : '']" @click="scrollToSection(index); navMove = index;"  v-for="(item, index) in filteredList" :key="index">
                    {{ getNavigationLabel(item.name) }}
                </button>
                
            </div>
        <div class="container-fluid mb-4">
            <div v-if="pageLoader">
                <PageLoader></PageLoader>
            </div>
            <div v-else class="mt-4 profile-body-holder">
                <div class="row">
                    <div class="col-md-3">
                        <div class="white-bg mb-3">
                            <div class="prifile-pix" :class="{ 'loading': isUploadingPix }">
                                <img v-if="userObjectUrl.passportfile == null" src="../assets/icons/profile-icon.svg" alt="profile" :class="{ 'uploading-border': isUploadingPix }">
                                <img class="uploading-border loading" v-else :src="userObjectUrl.passportfile" alt="profile">
                                <!-- <img v-else src="../assets/images/prop5.svg" alt="profile"> -->

                                <div class="camera-icon" @click="$refs.cam.click()">
                                    <input ref="cam" type="file" class="d-none" @change="selectProfileImage($event)">
                                    <svg width="43" height="44" viewBox="0 0 43 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21.5791 14.9141C17.7634 14.9141 14.5391 18.1384 14.5391 21.9541C14.5391 25.7697 17.7634 28.9941 21.5791 28.9941C25.3947 28.9941 28.6191 25.7697 28.6191 21.9541C28.6191 18.1384 25.3947 14.9141 21.5791 14.9141ZM21.5791 25.4741C19.7047 25.4741 18.0591 23.8285 18.0591 21.9541C18.0591 20.0797 19.7047 18.4341 21.5791 18.4341C23.4535 18.4341 25.0991 20.0797 25.0991 21.9541C25.0991 23.8285 23.4535 25.4741 21.5791 25.4741Z" fill="#374151"/>
                                        <path d="M35.6585 9.63547H31.1072L26.3428 4.87115C26.1797 4.7074 25.9857 4.57753 25.7722 4.48903C25.5586 4.40052 25.3297 4.35514 25.0985 4.35547H18.0585C17.8273 4.35514 17.5984 4.40052 17.3848 4.48903C17.1713 4.57753 16.9774 4.7074 16.8142 4.87115L12.0499 9.63547H7.49852C5.55724 9.63547 3.97852 11.2142 3.97852 13.1555V32.5155C3.97852 34.4567 5.55724 36.0355 7.49852 36.0355H35.6585C37.5998 36.0355 39.1785 34.4567 39.1785 32.5155V13.1555C39.1785 11.2142 37.5998 9.63547 35.6585 9.63547ZM7.49852 32.5155V13.1555H12.7785C13.2467 13.1555 13.6937 12.9707 14.0228 12.6398L18.7872 7.87547H24.3699L29.1342 12.6398C29.2974 12.8035 29.4913 12.9334 29.7048 13.0219C29.9184 13.1104 30.1473 13.1558 30.3785 13.1555H35.6585L35.662 32.5155H7.49852Z" fill="black"/>
                                    </svg>
                                </div>
                            </div>

                            <div class="mt-5">
                                <div class="profile-details">
                                    <h5>{{ userAccount === 'individual' ? 'First name' : 'Organization name' }}</h5>
                                    <h6 style="justify-content: left;">{{ userObjectUrl.firstname }} <span style="margin-left: 10px;" v-if="userAccount === 'individual'">{{ userObjectUrl.lastname }}</span></h6>
                                    <hr>
                                </div>
                                <div class="profile-details">
                                    <h5>Joined</h5>
                                    <h6>{{ userObjectUrl.created_at | moment2 }}</h6>
                                    <hr>
                                </div>
                                <div class="profile-details">
                                    <h5>Referral code</h5>
                                    <h6>{{ userObjectUrl.usercode }}
                                        <span @click="copyAccountNumber( userObjectUrl.usercode)">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14 8H4C2.897 8 2 8.897 2 10V20C2 21.103 2.897 22 4 22H14C15.103 22 16 21.103 16 20V10C16 8.897 15.103 8 14 8Z" fill="#00155F"/>
                                                <path d="M20 2H10C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4V6H16C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8V16H20C20.5304 16 21.0391 15.7893 21.4142 15.4142C21.7893 15.0391 22 14.5304 22 14V4C22 3.46957 21.7893 2.96086 21.4142 2.58579C21.0391 2.21071 20.5304 2 20 2Z" fill="#00155F"/>
                                            </svg>
                                        </span>
                                    </h6>
                                    <hr>
                                </div>
                                <!-- <div class="profile-details">
                                    <h5>Invite a friend</h5>
                                    <h6>Shlta-yrh-6648-hji 
                                        <span>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14 8H4C2.897 8 2 8.897 2 10V20C2 21.103 2.897 22 4 22H14C15.103 22 16 21.103 16 20V10C16 8.897 15.103 8 14 8Z" fill="#00155F"/>
                                                <path d="M20 2H10C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4V6H16C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8V16H20C20.5304 16 21.0391 15.7893 21.4142 15.4142C21.7893 15.0391 22 14.5304 22 14V4C22 3.46957 21.7893 2.96086 21.4142 2.58579C21.0391 2.21071 20.5304 2 20 2Z" fill="#00155F"/>
                                            </svg>
                                        </span>
                                    </h6>        
                                    <hr>
                                </div> -->

                                <div class="profile-details">
                                    <h5>Profile Setup</h5>
                                    <div class="progress mt-3">
                                        <div class="progress-bar bg-success" role="progressbar" :style="{ width: fullObjectUser.percentage_complete + '%'}"  aria-valuenow="60" aria-valuemin="0" aria-valuemax="100">
                                            <!-- {{fullObjectUser.percentage_complete}}% -->
                                        </div>
                                    </div>

                                    <div class="bottom-profile">
                                        <h5>{{ fullObjectUser.percentage_complete }}% Completed</h5>
                                        <h6>Complete profile set up and earn 
                                            
                                        </h6>
                                        <p>shelta points</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9" >
                        <div  class="white-bg mb-3" ref='mySection'>
                            <div v-if="navMove == 0">
                                <div class="top-headings">
                                        <div class="">
                                            <h4 class="headings">Personal Info</h4>
                                            <h6 class="subheadings d-none d-sm-block">View your information and make edits , if any and note that all info will be verify.</h6>
                                        </div>
                                        <div>
                                            <button :disabled="loader" class="btn outlinedBtnn d-none d-sm-block" @click="profileSetup()">
                                                <span>
                                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.9264 3.59924L5.71636 12.2892C5.40636 12.6192 5.10636 13.2692 5.04636 13.7192L4.67636 16.9592C4.54636 18.1292 5.38636 18.9292 6.54636 18.7292L9.76636 18.1792C10.2164 18.0992 10.8464 17.7692 11.1564 17.4292L19.3664 8.73924C20.7864 7.23924 21.4264 5.52924 19.2164 3.43924C17.0164 1.36924 15.3464 2.09924 13.9264 3.59924Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M12.5557 5.05078C12.9857 7.81078 15.2257 9.92078 18.0057 10.2008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M3.66602 22H21.666" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>

                                                </span> 
                                               {{ loader ? 'Updating...' : ' Edit info' }}
                                            </button>
                                        </div>
                                </div>
                                <div class="row" style="display: flex !important;">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="firstname">{{  userAccount === 'individual' ? 'First name' : 'Organization name' }}</label>
                                            <input type="text" class="form-control" id="firstname" :placeholder=" userAccount === 'individual' ? 'First name' : 'Organization name' " v-model="userObjectUrl.firstname">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="userAccount === 'individual'">
                                        <div class="form-group">
                                            <label class="the-label" for="lastname">Last name</label>
                                            <input type="text" class="form-control" id="lastname" placeholder="Last name"  v-model="userObjectUrl.lastname">
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6" v-if="userAccount === 'individual'">
                                        <div class="form-group">
                                            <label class="the-label" for="othername">Other name</label>
                                            <input type="text" class="form-control" id="othername" placeholder="Other name"  v-model="userObjectUrl.othernames">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="email">Email</label>
                                            <input disabled type="email" class="form-control" id="email" placeholder="Email Address"  v-model="userObjectUrl.email">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="phonenumber">Phone number</label>
                                            <input type="text" class="form-control" id="phonenumber" placeholder="Phone number"  v-model="userObjectUrl.phone">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="state">State</label>
                                            <select name="" id="state" class="form-control" v-model="userObjectUrl.stateid" @change="getcitiesbystateid($event)">
                                                <option value="" selected disabled>Select state</option>
                                                <option v-for="(state, index) in getstates" :key="index" :value="state.id">{{state.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="city">City</label>
                                            <select :disabled="cityloading" name="" id="city" class="form-control"  v-model="userObjectUrl.cityid">
                                                <option value="" selected disabled>Select city</option>
                                                <option v-for="(city, index) in getcities" :key="index" :value="city.id">{{city.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="address">Address</label>
                                           <textarea name="address" class="form-control text-area" id="address" placeholder="Enter your house address" v-model="userObjectUrl.address"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group d-block d-sm-none mt-4">
                                    <button :disabled="loader" class="btn outlinedBtnn w-100" @click="profileSetup()">
                                        <span>
                                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.9264 3.59924L5.71636 12.2892C5.40636 12.6192 5.10636 13.2692 5.04636 13.7192L4.67636 16.9592C4.54636 18.1292 5.38636 18.9292 6.54636 18.7292L9.76636 18.1792C10.2164 18.0992 10.8464 17.7692 11.1564 17.4292L19.3664 8.73924C20.7864 7.23924 21.4264 5.52924 19.2164 3.43924C17.0164 1.36924 15.3464 2.09924 13.9264 3.59924Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12.5557 5.05078C12.9857 7.81078 15.2257 9.92078 18.0057 10.2008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M3.66602 22H21.666" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                        </span> 
                                        {{ loader ? 'Updating...' : ' Edit info' }}
                                    </button>
                                </div>
                                <!-- <div class="form-group">
                                    
                                    <h5 class="update-status">Personal info, update stats</h5>
                                    <div class="progress mt-3">
                                        <div class="progress-bar bg-success" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"> 
                                        </div>
                                    
                                    </div>
                                    <small class="verified-text">Verified</small>
                                </div> -->
                            </div>
                            <div v-if="navMove == 1">
                                <div class="top-headings">
                                        <div class="">
                                            <h4 class="headings">Next of kin</h4>
                                            <h6 class="subheadings d-none d-sm-block">View your information and make edits , if any and note that all info will be verify.</h6>
                                        </div>
                                        <div>
                                            <button :disabled="loader" class="btn outlinedBtnn d-none d-sm-block" @click="updateNextofKin()">
                                                <span>
                                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.9264 3.59924L5.71636 12.2892C5.40636 12.6192 5.10636 13.2692 5.04636 13.7192L4.67636 16.9592C4.54636 18.1292 5.38636 18.9292 6.54636 18.7292L9.76636 18.1792C10.2164 18.0992 10.8464 17.7692 11.1564 17.4292L19.3664 8.73924C20.7864 7.23924 21.4264 5.52924 19.2164 3.43924C17.0164 1.36924 15.3464 2.09924 13.9264 3.59924Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M12.5557 5.05078C12.9857 7.81078 15.2257 9.92078 18.0057 10.2008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M3.66602 22H21.666" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>

                                                </span> 
                                                {{ loader ? 'Updating...' : ' Edit info' }}
                                            </button>
                                        </div>
                                </div>
                                <div class="row" style="display: flex !important;">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="fullnamen">Fullname</label>
                                            <input type="text" class="form-control" id="fullnamen" placeholder="Fullname" v-model="fullObjectUser.nextofkin.fullname">
                                        </div>
                                    </div>
                                    

                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="emailn">Email</label>
                                            <input type="email" class="form-control" id="emailn" placeholder="Email Address" v-model="fullObjectUser.nextofkin.email">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="phonenumbern">Phone number</label>
                                            <input type="text" class="form-control" id="phonenumbern" placeholder="Phone number" v-model="fullObjectUser.nextofkin.phone">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="relationshipn">Relationship</label>
                                            <input type="text" class="form-control" id="relationshipn" placeholder="Relationshio" v-model="fullObjectUser.nextofkin.relationship">
                                        </div>
                                    </div>
                                   
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="the-label" for="addressn">Present address</label>
                                           <textarea name="address" class="form-control text-area" id="addressn" placeholder="Enter house address" v-model="fullObjectUser.nextofkin.address"></textarea>
                                        </div>
                                    </div>
                                </div>

                                
                                <div class="form-group mt-4 d-block d-sm-none">
                                    <button :disabled="loader" class="btn outlinedBtnn w-100" @click="updateNextofKin()">
                                        <span>
                                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.9264 3.59924L5.71636 12.2892C5.40636 12.6192 5.10636 13.2692 5.04636 13.7192L4.67636 16.9592C4.54636 18.1292 5.38636 18.9292 6.54636 18.7292L9.76636 18.1792C10.2164 18.0992 10.8464 17.7692 11.1564 17.4292L19.3664 8.73924C20.7864 7.23924 21.4264 5.52924 19.2164 3.43924C17.0164 1.36924 15.3464 2.09924 13.9264 3.59924Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12.5557 5.05078C12.9857 7.81078 15.2257 9.92078 18.0057 10.2008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M3.66602 22H21.666" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                        </span> 
                                        {{ loader ? 'Updating...' : ' Edit info' }}
                                    </button>
                                </div>
                                <!-- <div class="form-group">
                                    
                                    <h5 class="update-status">Next of kin, update stats</h5>
                                    <div class="progress mt-3">
                                        <div class="progress-bar bg-success" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"> 
                                        </div>
                                    
                                    </div>
                                    <small class="verified-text">Verified</small>
                                </div> -->
                            </div>
                            <div v-if="navMove == 2">
                                <div class="top-headings">
                                        <div class="">
                                            <h4 class="headings">Career or Occupation</h4>
                                            <h6 class="subheadings d-none d-sm-block">View your information and make edits , if any and note that all info will be verify.</h6>
                                        </div>
                                        <div>
                                            <button :disabled="loader" class="btn outlinedBtnn d-none d-sm-block" @click="occupationUpdatingOption()">
                                                <span>
                                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.9264 3.59924L5.71636 12.2892C5.40636 12.6192 5.10636 13.2692 5.04636 13.7192L4.67636 16.9592C4.54636 18.1292 5.38636 18.9292 6.54636 18.7292L9.76636 18.1792C10.2164 18.0992 10.8464 17.7692 11.1564 17.4292L19.3664 8.73924C20.7864 7.23924 21.4264 5.52924 19.2164 3.43924C17.0164 1.36924 15.3464 2.09924 13.9264 3.59924Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M12.5557 5.05078C12.9857 7.81078 15.2257 9.92078 18.0057 10.2008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M3.66602 22H21.666" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>

                                                </span> 
                                                {{ loader ? 'Updating...' : ' Edit info' }}
                                            </button>
                                        </div>
                                </div>
                                <div class="row" style="display: flex !important;">
                                    
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="employmentstatus">Employment status</label>
                                            <select name="" id="employmentstatus" class="form-control" v-model="userObjectUrl.occupationid">
                                                <option value="" disabled>Select occupation type</option>
                                                <option
                                                    v-for="item in occupationTypes"
                                                    :key="item.id"
                                                    :value="item.id"
                                                    >{{ item.occupation }}
                                                </option
                                                >
                                            </select>
                                        </div>
                                    </div>
                                    
                                    <div class="col-12 col-md-6" v-if="userObjectUrl.occupationid == '1' || userObjectUrl.occupationid == '2' || userObjectUrl.occupationid == '3'">
                                        <div class="form-group">
                                            <label class="the-label" for="companyname">Company name</label>
                                            <input type="text" class="form-control" id="companyname" placeholder="Company name" v-model="nameOfBusiness">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="userObjectUrl.occupationid == '1' || userObjectUrl.occupationid == '2' || userObjectUrl.occupationid == '3'">
                                        <div class="form-group">
                                            <label class="the-label" for="companysector">Business sector</label>
                                            <input type="text" class="form-control" id="companysector" placeholder="Company sector" v-model="businessSector">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="userObjectUrl.occupationid == '1' || userObjectUrl.occupationid == '2' || userObjectUrl.occupationid == '3'">
                                        <div class="form-group">
                                            <label class="the-label" for="businesstype">Business type</label>
                                            <input type="text" class="form-control" id="businesstype" placeholder="Business type" v-model="typeOfBusiness">
                                        </div>
                                    </div>
                                    
                                    
                                    <div :class="[isRegistered == '1' ? 'col-12 col-md-6' : 'col-12']"  v-if="userObjectUrl.occupationid == '1' || userObjectUrl.occupationid == '2' || userObjectUrl.occupationid == '3'">
                                        <div class="form-group">
                                            <label class="the-label" for="companytype">Is your business registered?</label>
                                            <select name="" id="companytype" class="form-control" v-model="isRegistered">
                                                <option value="" selected disabled>Is your business registered</option>
                                                <option value="1">Yes</option>
                                                <option value="0">No</option>
                                            </select>
                                        </div>
                                    </div>

                                
                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '1' || userObjectUrl.occupationid == '2' || userObjectUrl.occupationid == '3') && isRegistered == '1'">
                                        <div class="form-group">
                                            <label class="the-label" for="companytype">Type of registration</label>
                                            <select name="" id="companytype" class="form-control" v-model="businessRegType">
                                                <option value="" selected disabled>Type of registration</option>
                                                <option value="Business Name">Business Name</option>
                                                <option value="Limited Liability Company">Limited Liability Company</option>
                                                <option value="Incorpurated Trustee">Incorpurated Trustee</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '1' || userObjectUrl.occupationid == '2' || userObjectUrl.occupationid == '3') && isRegistered == '1'">
                                        <div class="form-group">
                                            <label class="the-label" for="registrationnumber">Registration number</label>
                                            <input type="text" class="form-control" id="registrationnumber" placeholder="Registration Number" v-model="registrationNumber">
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '1' || userObjectUrl.occupationid == '2' || userObjectUrl.occupationid == '3') && isRegistered == '1'">
                                        <div class="form-group">
                                            <label class="the-label" for="Certificateofincoporationname">Certificate of incoporation name</label>
                                            <input type="text" class="form-control" id="Certificateofincoporationname" placeholder="Certificate of incoporation name" v-model="certificateOfIncoporation">
                                        </div>
                                    </div>


                                    <div class="col-12" v-if="userObjectUrl.occupationid == '1' || userObjectUrl.occupationid == '2' || userObjectUrl.occupationid == '3'">
                                        <div class="form-group">
                                            <label class="the-label" for="companyaddress">Company address</label>
                                            <textarea name="address" class="form-control text-area" id="companyaddress" placeholder="Company address" v-model="businessAddress"></textarea>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '4' || userObjectUrl.occupationid == '6')">
                                        <div class="form-group">
                                            <label class="the-label" for="lastworkplace">Last place of employment</label>
                                            <input type="text" class="form-control" id="lastworkplace" placeholder="Last place of employment" v-model="lastWorkPlace">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '4' || userObjectUrl.occupationid == '6')">
                                        <div class="form-group">
                                            <label class="the-label" for="dateofdisengagement">Date of disengagement</label>
                                            <input type="date" class="form-control" id="dateofdisengagement" :max="today" placeholder="Date of disengagement" v-model="dateOfDisengagement">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '4' || userObjectUrl.occupationid == '6')">
                                        <div class="form-group">
                                            <label class="the-label" for="addressunemployed">Last work address</label>
                                            <input type="text" class="form-control" id="addressunemployed" placeholder="Address" v-model="unemployedAddress">
                                        </div>
                                    </div>
                            
                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '4' || userObjectUrl.occupationid == '6')">
                                        <div class="form-group">
                                            <label class="the-label" for="lastplacephone">Last employer phone number</label>
                                            <input type="text" class="form-control" id="lastplacephone" placeholder="Last place employer phone" v-model="unemployedPhone">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '4' || userObjectUrl.occupationid == '6')">
                                        <div class="form-group">
                                            <label class="the-label" for="currentSourceOfIncome">Current source of income</label>
                                            <input type="text" class="form-control" id="currentSourceOfIncome" placeholder="Current source of income" v-model="currentSourceOfIncome">
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '5' || userObjectUrl.occupationid == '7')">
                                        <div class="form-group panel-input" id="org" ref="orgg">
                                            <label class="the-label" for="orgname">Organization name</label>
                                            <input type="text" class="form-control" id="orgname" placeholder="Organization name" v-model="nameofOrganization"
                                            @focus="runOption($event)"
                                            @keyup="filterOrganization(nameofOrganization)"
                                            ref="openPanel"
                                            >
                                            <span
                                                @click="openOption = !openOption"
                                            >
                                                <i class="fa fa-chevron-up" :class="[!openOption ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                                            </span>
                                            <div v-if="openOption && organizations.length > 0" class="option-list">
                                                <div
                                                class="handler-list"
                                                v-for="(item, index) in organizations"
                                                :key="index"
                                                >
                                                <li
                                                    :class="[
                                                    item.firstname === nameofOrganization
                                                        ? 'activeHandler'
                                                        : ''
                                                    ]"
                                                    @click="
                                                    selectPanel(item.firstname, item.id, item)
                                                    "
                                                >
                                                    {{ item.firstname }}
                                                </li>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '5' || userObjectUrl.occupationid == '7')">
                                        <div class="form-group">
                                            <label class="the-label" for="orgaddress">Organization address</label>
                                            <input type="text" class="form-control" id="orgaddress" placeholder="Organization address" v-model="employAddress">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '5' || userObjectUrl.occupationid == '7')">
                                        <div class="form-group">
                                            <label class="the-label" for="jopbtitle">Job Title</label>
                                            <input type="text" class="form-control" id="jopbtitle" placeholder="Job title" v-model="jobTitle">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '5' || userObjectUrl.occupationid == '7')">
                                        <div class="form-group">
                                            <label class="the-label" for="dateemployed">Date of employment</label>
                                            <input type="date" class="form-control" id="dateemployed" :max="today" placeholder="Date employed" v-model="dateofEmployment">
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6" v-if="(userObjectUrl.occupationid == '5' || userObjectUrl.occupationid == '7')">
                                        <div class="form-group">
                                            <label class="the-label" for="contactphone">Phone number Employee</label>
                                            <input type="text" class="form-control" id="contactphone" placeholder="Phone number of employee" v-model="employPhone">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group mt-4 d-block d-sm-none">
                                    <button :disabled="loader" class="btn outlinedBtnn w-100" @click="occupationUpdatingOption()">
                                        <span>
                                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.9264 3.59924L5.71636 12.2892C5.40636 12.6192 5.10636 13.2692 5.04636 13.7192L4.67636 16.9592C4.54636 18.1292 5.38636 18.9292 6.54636 18.7292L9.76636 18.1792C10.2164 18.0992 10.8464 17.7692 11.1564 17.4292L19.3664 8.73924C20.7864 7.23924 21.4264 5.52924 19.2164 3.43924C17.0164 1.36924 15.3464 2.09924 13.9264 3.59924Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12.5557 5.05078C12.9857 7.81078 15.2257 9.92078 18.0057 10.2008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M3.66602 22H21.666" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                        </span> 
                                        {{ loader ? 'Updating...' : ' Edit info' }}
                                    </button>
                                </div>
                                <!-- <div class="form-group">
                                    
                                    <h5 class="update-status">Career/Occupation, update stats</h5>
                                    <div class="progress mt-3">
                                        <div class="progress-bar bg-success" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"> 
                                        </div>
                                    
                                    </div>
                                    <small class="verified-text">Verified</small>
                                </div> -->
                            </div>
                            <div v-if="navMove == 3">
                                <div class="top-headings">
                                    <div class="">
                                        <h4 class="headings">Emergency contact info</h4>
                                        <h6 class="subheadings d-none d-sm-block">View your information and make edits , if any and note that all info will be verify.</h6>
                                    </div>
                                    <div>
                                        <button :disabled="loader" class="btn outlinedBtnn d-none d-sm-block" @click="updateEmergencyContact()">
                                            <span>
                                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.9264 3.59924L5.71636 12.2892C5.40636 12.6192 5.10636 13.2692 5.04636 13.7192L4.67636 16.9592C4.54636 18.1292 5.38636 18.9292 6.54636 18.7292L9.76636 18.1792C10.2164 18.0992 10.8464 17.7692 11.1564 17.4292L19.3664 8.73924C20.7864 7.23924 21.4264 5.52924 19.2164 3.43924C17.0164 1.36924 15.3464 2.09924 13.9264 3.59924Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12.5557 5.05078C12.9857 7.81078 15.2257 9.92078 18.0057 10.2008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M3.66602 22H21.666" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>

                                            </span> 
                                            {{ loader ? 'Updating...' : ' Edit info' }}
                                        </button>
                                    </div>
                                </div>
                                <div class="row" style="display: flex !important;">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="fullnamee">Fullname</label>
                                            <input type="text" class="form-control" id="fullnamene" placeholder="Fullname" v-model="fullnameem">
                                        </div>
                                    </div>
                                  

                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="emaile">Email</label>
                                            <input type="email" class="form-control" id="emaile" placeholder="Email Address" v-model="emailem">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="phonenumbere">Phone number</label>
                                            <input type="text" class="form-control" id="phonenumbere" placeholder="Phone number" v-model="phoneem">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="relationshipe">Relationship</label>
                                            <input type="text" class="form-control" id="relationshipe" placeholder="Relationship" v-model="relationshipem">
                                        </div>
                                    </div>
                                   
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="the-label" for="addressn">Present address</label>
                                           <textarea name="address" class="form-control text-area" id="addresns" placeholder="Enter your house address" v-model="addressem"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group mt-4 d-block d-sm-none">
                                    <button :disabled="loader" class="btn outlinedBtnn w-100" @click="updateEmergencyContact()">
                                        <span>
                                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.9264 3.59924L5.71636 12.2892C5.40636 12.6192 5.10636 13.2692 5.04636 13.7192L4.67636 16.9592C4.54636 18.1292 5.38636 18.9292 6.54636 18.7292L9.76636 18.1792C10.2164 18.0992 10.8464 17.7692 11.1564 17.4292L19.3664 8.73924C20.7864 7.23924 21.4264 5.52924 19.2164 3.43924C17.0164 1.36924 15.3464 2.09924 13.9264 3.59924Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12.5557 5.05078C12.9857 7.81078 15.2257 9.92078 18.0057 10.2008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M3.66602 22H21.666" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                        </span> 
                                        {{ loader ? 'Updating...' : ' Edit info' }}
                                    </button>
                                </div>
                                <!-- <div class="form-group">
                                    
                                    <h5 class="update-status">Emergency contact, update stats</h5>
                                    <div class="progress mt-3">
                                        <div class="progress-bar bg-success" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"> 
                                        </div>
                                    
                                    </div>
                                    <small class="verified-text">Verified</small>
                                </div> -->
                            </div>
                            <div v-if="navMove == 4">
                                <div class="top-headings">
                                        <div class="">
                                            <h4 class="headings">Guarantor information</h4>
                                            <h6 class="subheadings d-none d-sm-block">View your information and make edits , if any and note that all info will be verify.</h6>
                                        </div>
                                        <div>
                                            <button :disabled="loader" class="btn outlinedBtnn d-none d-sm-block" @click="updateGuarantor()">
                                                <span>
                                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.9264 3.59924L5.71636 12.2892C5.40636 12.6192 5.10636 13.2692 5.04636 13.7192L4.67636 16.9592C4.54636 18.1292 5.38636 18.9292 6.54636 18.7292L9.76636 18.1792C10.2164 18.0992 10.8464 17.7692 11.1564 17.4292L19.3664 8.73924C20.7864 7.23924 21.4264 5.52924 19.2164 3.43924C17.0164 1.36924 15.3464 2.09924 13.9264 3.59924Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M12.5557 5.05078C12.9857 7.81078 15.2257 9.92078 18.0057 10.2008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M3.66602 22H21.666" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>

                                                </span> 
                                                {{ loader ? 'Updating...' : ' Edit info' }}
                                            </button>
                                        </div>
                                </div>
                                <div class="row" style="display: flex !important;">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="fullnameg">Fullname</label>
                                            <input type="text" class="form-control" id="fullnameg" placeholder="Fullname" v-model="fullnameg">
                                        </div>
                                    </div>
                                   

                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="emailg">Email</label>
                                            <input type="email" class="form-control" id="emailg" placeholder="Email Address" v-model="emailg">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="phonenumberg">Phone number</label>
                                            <input type="text" class="form-control" id="phonenumberg" placeholder="Phone number" v-model="phoneg">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label class="the-label" for="relationshipg">Relationship</label>
                                            <input type="text" class="form-control" id="relationshipg" placeholder="Relationship" v-model="relationshipg">
                                        </div>
                                    </div>
                                   
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="the-label" for="addresseg">Present address</label>
                                           <textarea name="address" class="form-control text-area" id="addresseg" placeholder="Enter your house address" v-model="addressg"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group mt-4 d-block d-sm-none">
                                    <button :disabled="loader" class="btn outlinedBtnn w-100" @click="updateGuarantor()">
                                        <span>
                                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.9264 3.59924L5.71636 12.2892C5.40636 12.6192 5.10636 13.2692 5.04636 13.7192L4.67636 16.9592C4.54636 18.1292 5.38636 18.9292 6.54636 18.7292L9.76636 18.1792C10.2164 18.0992 10.8464 17.7692 11.1564 17.4292L19.3664 8.73924C20.7864 7.23924 21.4264 5.52924 19.2164 3.43924C17.0164 1.36924 15.3464 2.09924 13.9264 3.59924Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12.5557 5.05078C12.9857 7.81078 15.2257 9.92078 18.0057 10.2008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M3.66602 22H21.666" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                        </span> 
                                        {{ loader ? 'Updating...' : ' Edit info' }}
                                    </button>
                                </div>
                                <!-- <div class="form-group">
                                    
                                    <h5 class="update-status">Emergency contact, update stats</h5>
                                    <div class="progress mt-3">
                                        <div class="progress-bar bg-success" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"> 
                                        </div>
                                    
                                    </div>
                                    <small class="verified-text">Verified</small>
                                </div> -->
                            </div>
                            <div v-if="navMove == 5">
                                <div class="top-headings">
                                        <div class="">
                                            <h4 class="headings">Documents</h4>
                                            <h6 class="subheadings d-none d-sm-block">View/Edit your documents and make any if any.</h6>
                                        </div>
                                        <div>
                                            <button class="btn outlinedBtnn d-none d-sm-block" data-toggle="modal" data-target="#uploaddoc">
                                                <span>
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M9 17V11L7 13" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M9 11L11 13" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>


                                                </span> 
                                               Uploads
                                            </button>
                                        </div>
                                </div>
                                <div>
                                    <div class="table-holder">
                                        <!-- <h4 class="t-history">Documents</h4> -->

                                        <div class="table-responsive tableList">
                                            <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                                                <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Document type</th>
                                                        <th scope="col">Action</th>
                                                        <!-- <th scope="col"></th> -->
                                                        <th scope="col"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <!-- v-for="(item, index) in landlords"
                                                        :key="index" -->
                                                    <tr>
                                                        <td>Means of identification</td>
                                                        <td v-if="fulldata.user_object.meansofidfileurl != null" style="text-decoration: underline;" data-toggle="modal" data-target="#viewdata">View</td>
                                                        <td v-else>No file yet</td>
                                                        <!-- <td style="color: #FB3748;">Delete
                                                            <span style=" padding-left: 5px;">
                                                                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M5.22266 5.83464H4.38932V16.668C4.38932 17.11 4.56492 17.5339 4.87748 17.8465C5.19004 18.159 5.61396 18.3346 6.05599 18.3346H14.3893C14.8314 18.3346 15.2553 18.159 15.5678 17.8465C15.8804 17.5339 16.056 17.11 16.056 16.668V5.83464H5.22266ZM8.55599 15.8346H6.88932V8.33464H8.55599V15.8346ZM13.556 15.8346H11.8893V8.33464H13.556V15.8346ZM14.071 3.33464L12.7227 1.66797H7.72266L6.37432 3.33464H2.72266V5.0013H17.7227V3.33464H14.071Z" fill="#FB3748"/>
                                                                </svg>
                                                            </span>
                                                        </td> -->
                                                    </tr>  
                                                    
                                                </tbody>
                                            </table>
                                            <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                                                <EmptyState :emptyData="emptyDataObject2" />
                                            </div> -->
                                        </div>

                                    </div>
                                </div>
                                <div class="form-group mt-4 d-block d-sm-none">
                                    <button class="btn outlinedBtnn w-100" data-toggle="modal" data-target="#uploaddoc">
                                        <span class="pr-3">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 17V11L7 13" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9 11L11 13" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>


                                        </span> 
                                        Upload documents
                                    </button>
                                </div>
                                <!-- <div class="form-group">
                                    
                                    <h5 class="update-status">Document verification status</h5>
                                    <div class="progress mt-3">
                                        <div class="progress-bar bg-success" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"> 
                                        </div>
                                    
                                    </div>
                                    <small class="verified-text">Verified</small>
                                </div> -->


                                <div class="modal" tabindex="-1" id="uploaddoc">
                                    <div class="modal-dialog modal-dialog-center">
                                        <div class="modal-content">
                                        <div class="modal-header" @click="closeModalNow()">
                                            <h5 class="modal-title modal-top">Upload document</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <!-- v-for="(identify, index) in identifcationType" :key="index"
                                                        v-bind:value="identify.name -->
                                            <div class="form-group">
                                                <label class="the-label" for="relationshipe">Document type</label>
                                                <select name="" id="relationshipe" class="form-control" v-model="meansType">
                                                    <option value="" selected disabled>Select document to upload</option>
                                                    <option v-for="(item , index) in identifcationType" :key="index" :value="item.name">{{ item.name }}</option>
                                                </select>
                                            </div>

                                            <div class="upload-area" @click="$refs.doc.click()"> 
                                                <input ref="doc" type="file" name="" id="" class="d-none" @change="selectDocToUpload($event)">
                                                <div v-if="fileselected == '' || fileselected == null">
                                                    <div>
                                                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g filter="url(#filter0_d_9522_18444)">
                                                                <rect x="2" y="1" width="40" height="40" rx="8" fill="white" shape-rendering="crispEdges"/>
                                                                <rect x="2.5" y="1.5" width="39" height="39" rx="7.5" stroke="#EAECF0" shape-rendering="crispEdges"/>
                                                                <path d="M22.8337 26.832V23.4987H25.3337L22.0003 19.332L18.667 23.4987H21.167V26.832H22.8337Z" fill="#333333"/>
                                                                <path d="M17.8337 26.8346H19.5003V25.168H17.8337C16.4553 25.168 15.3337 24.0463 15.3337 22.668C15.3337 21.498 16.3328 20.3713 17.5612 20.1555L18.0453 20.0705L18.2053 19.6055C18.7912 17.8963 20.2462 16.8346 22.0003 16.8346C24.2978 16.8346 26.167 18.7038 26.167 21.0013V21.8346H27.0003C27.9195 21.8346 28.667 22.5821 28.667 23.5013C28.667 24.4205 27.9195 25.168 27.0003 25.168H24.5003V26.8346H27.0003C28.8387 26.8346 30.3337 25.3396 30.3337 23.5013C30.3324 22.7543 30.0809 22.0293 29.6192 21.442C29.1576 20.8547 28.5125 20.439 27.787 20.2613C27.4228 17.393 24.967 15.168 22.0003 15.168C19.7037 15.168 17.7087 16.5105 16.7978 18.6263C15.0078 19.1613 13.667 20.8513 13.667 22.668C13.667 24.9655 15.5362 26.8346 17.8337 26.8346Z" fill="#333333"/>
                                                                </g>
                                                            <defs>
                                                                <filter id="filter0_d_9522_18444" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                                    <feOffset dy="1"/>
                                                                    <feGaussianBlur stdDeviation="1"/>
                                                                    <feComposite in2="hardAlpha" operator="out"/>
                                                                    <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
                                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9522_18444"/>
                                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9522_18444" result="shape"/>
                                                                </filter>
                                                            </defs>
                                                        </svg>

                                                    </div>

                                                    <h3>Click to upload or drag and drop</h3>
                                                    <h5>Upload documents, max size 5Mb</h5>
                                                    <h6>Supported file formats PNG, JPEG, GIF or PDF</h6>
                                                </div>
                                                <!-- <p>{{ fileToUpload }}</p> -->
                                                <img class="w-100" style="object-fit: cover;" v-if="fileselected.type === 'image/jpeg' && fileselected != ''" :src="imagePreview" alt="">
                                                <div v-if="fileselected.type === 'application/pdf' && fileselected != ''">
                                                    <iframe
                                                        :src="imagePreview"
                                                        width="100%"
                                                        height="500px"
                                                        style="border: 1px solid #ccc;"
                                                    >
                                                    </iframe>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="modal-footer">
                                            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                                            <button type="button" class="btn outlinedBtnn" @click="closeModalNow(); modalClose();" data-dismiss="modal" aria-label="Close">
                                                Cancel
                                            </button>
                                            <button :disabled="uploading" type="button" class="btn sheltaBtn" @click="uploadMeansOfId()">
                                                Save changes
                                                <span v-if="uploading"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                                            </button>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="modal" tabindex="-1" id="viewdata">
                                    <div class="modal-dialog modal-dialog-center">
                                        <div class="modal-content">
                                        <div class="modal-header" @click="closeModalNow()">
                                            <h5 class="modal-title modal-top">Uploaded document</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="upload-area"> 
                                                <img class="w-100" style="object-fit: cover;" :src="fulldata.user_object.meansofidfileurl" alt="means of id">
                                            </div>
                                            
                                        </div>
                                        <div class="modal-footer">
                                            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                                            <button type="button" class="btn outlinedBtnn" data-dismiss="modal" aria-label="Close">
                                                Cancel
                                            </button>
                                            <!-- <button :disabled="uploading" type="button" class="btn sheltaBtn" @click="uploadMeansOfId()">
                                                Save changes
                                                <span v-if="uploading"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                                            </button> -->
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="navMove == 6">
                                <div class="top-headings">
                                    <div class="">
                                        <h4 class="headings">Association</h4>
                                        <h6 class="subheadings d-none d-sm-block">View/select your association and make edit</h6>
                                    </div>
                                    <div>
                                        <button :disabled="loader" class="btn outlinedBtnn d-none d-sm-block" @click="updateAssociation()">
                                            <span>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 17V11L7 13" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M9 11L11 13" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>


                                            </span> 
                                            {{ loader ? 'Updating...' : ' Edit info' }}
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label class="the-label" for="relationshipe">Associations</label>
                                        <select name="" id="relationshipe" class="form-control" v-model="associationId">
                                            <option value="" selected disabled>Select association</option>
                                            <option v-for="(item , index) in associations" :key="index" :value="item.id">{{ item.firstname }}</option>
                                        </select>
                                    </div>
                                </div>
        
                                <div class="form-group mt-4 d-block d-sm-none">
                                    <button :disabled="loader" class="btn outlinedBtnn w-100" @click="updateAssociation()">
                                        {{ loader ? 'Updating...' : ' Edit info' }}
                                    </button>
                                </div>
                               
                            </div>

                            <div v-if="navMove == 7">
                                <div class="top-headings">
                                    <div class="">
                                        <h4 class="headings">AVERAGE MONTHLY INCOME</h4>
                                        <h6 class="subheadings d-none d-sm-block">View/select your financial status and make edit</h6>
                                    </div>
                                    <div>
                                        <button :disabled="loader" class="btn outlinedBtnn d-none d-sm-block" @click="monthlyIncome();">
                                            <span>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 17V11L7 13" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M9 11L11 13" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>


                                            </span> 
                                            {{ loader ? 'Updating...' : ' Edit info' }}
                                        </button>
                                    </div>
                                </div>

                                <div>
                                    <div class="form-group">
                                        <label class="the-label" for="income">Income Range</label>
                                        <select
                                            v-model="incomeSelected"
                                            class="form-control col-md-6 col-sm-12 input-bar"
                                            id="income"
                                            @change="getIncomeValue($event)"
                                        >
                                            <option disabled value=""
                                            >| Select income range</option
                                            >
                                            <option
                                            v-for="(income, index) in incomeInfo"
                                            :key="index"
                                            v-bind:value="income.name"
                                            >{{ income.name }}</option
                                            >
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group mt-4 d-block d-sm-none">
                                    <button :disabled="loader" class="btn outlinedBtnn w-100" @click="monthlyIncome()">
                                        {{ loader ? 'Updating...' : ' Edit info' }}
                                    </button>
                                </div>
                            </div>

                            <div v-if="navMove == 8">
                                <div class="top-headings">
                                    <div class="">
                                        <h4 class="headings">National Identification Number (NIN)</h4>
                                        <h6 class="subheadings d-none d-sm-block">View/enter your NIN and make edit</h6>
                                    </div>
                                    <div>
                                        <button :disabled="loader" class="btn outlinedBtnn d-none d-sm-block" @click="verifyNin();">
                                            <span>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 17V11L7 13" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M9 11L11 13" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>


                                            </span> 
                                            {{ loader ? 'Verifing...' : ' Veryfy NIN' }}
                                        </button>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="nin">NIN</label>
                                    <input type="number" class="form-control" placeholder="Enter NIN" v-model="nin">
                                </div>
                                <div class="" v-if="ninSuccess">
                                    <div class="row" style="display: flex !important;">
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label class="the-label" for="fnnin">Frst name</label>
                                                <input type="text" class="form-control" id="fnnin" placeholder="First name" v-model="ninObject.fnnin">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </div>
</template>



<script>
import '@/assets/styles/custom.scss';
import PageLoader from "./PageLoader.vue";
import { Service } from "../store/service";
const Api = new Service();
import moment from "moment";
import $ from "jquery";

export default {
    name: "ProfileNew",
    components: {
        // SmallNav
        PageLoader,
    },
    data() {
        return {
            pageLoader: false,
            loading: false,
            uploading: false,
            loader: false,
            isUploadingPix: false,
            cityloading: false,
            ninSuccess: false,
            navMove: 0,
            navButtons: [
                { name: 'Biodata' },
                { name: 'Contacts' },
                { name: 'Occupation' },
                { name: 'Emergency' },
                { name: 'Guarantor' },
                { name: 'Documents' },
                { name: 'Association'},
                { name: 'Financial Status'},
                { name: 'National Identification Number (NIN)'}
            ],
            identifcationType: [
                { name: "Voters card" },
                { name: "National passport"},
                { name: "Drivers licence" },
                { name: "International passport" }
            ],
            meansType: "",
            fileselected: "",
            fileToUpload: null,
            imagePreview: null,
            fileSizeInMb: "",
            user: "",
            userAccount: "organization",
            who_you: "Landlord",
            handlerId: '',
            openOption: false,
            disableInput: false,
            getCountries: "",
            userObjectUrl: {},
            fullObjectUser: {
                unemployed: {
                    dateofdisengagement: null,
                    lastworkplace: null,
                },
            },
            fulldata: "",
            emergency: "",
            fullnamenok: "",
            phonenok: "",
            emailnok: "",
            addressnok: "",
            relationshipnok: "",
            modeOfIdSelected: "",
            emplymentStatus: "",
            referrer: "",
            employAddress: "",
            nameofOrganization: "",
            jobTitle: "",
            dateofEmployment: "",
            employPhone: "",
            businessAddress: "",
            nameOfBusiness: "",
            typeOfBusiness: "",
            businessSector: "",
            isRegistered: "",
            certificateOfIncoporation: "",
            businessRegType: "",
            registrationNumber: "",
            unemployedAddress: "",
            lastWorkPlace: "",
            currentSourceOfIncome: "",
            unemployedPhone: "",
            dateOfDisengagement: "",
            incomeSelected: "",
            fullnameg: "",
            emailg: "",
            phoneg: "",
            addressg: "",
            relationshipg: "",
            fullnameem: "",
            emailem: "",
            phoneem: "",
            addressem: "",
            relationshipem: "",
            city: "",
            state: "",
            country: "",
            stateID: "",

            getstates: [],
            getcities: [],

            // occupationtypes: [],

            fileProfile: '',

            occupationTypes: [],
            occupationId: "",

            organizations: [],
            theRef: "",
            today: new Date().toISOString().split("T")[0], // YYYY-MM-DD
            associations: [],
            associationId: "",
            incomeInfo: [
                {
                name: "N50,000 - N100,000"
                },
                {
                name: "N100,000 - N500,000"
                },
                {
                name: "N500,000 - N1,000,000"
                },
                {
                name: "N1,000,000 - N2,000,000"
                },
                {
                name: "N2,000,000 - N5,000,000"
                },
                {
                name: "N5,000,000 - Above"
                }
            ],
            ninObject: {
                fnnin: "",
            },
            nin: "",

        }
    },
    computed: {
        lastworkplaceinput: {
            get() {
            return this.fullObjectUser.unemployed?.lastworkplace || '';
            },
            set(value) {
            if (!this.fullObjectUser.unemployed) {
                this.$set(this.fullObjectUser, 'unemployed', {});
            }
            this.fullObjectUser.unemployed.lastworkplace = value;
            }
        },
        filteredList() {
            // return this.navButtons.filter(item => {
            // // Condition: Hide if user is a man AND item name matches
            // // who_you === 'Tenant' && userAccount === 'individual'
            // const isHiddenForMen = this.who_you === 'Tenant' && this.userAccount === 'individual' && item.name === 'Financial status';
            // return !isHiddenForMen;
            // });

            return this.navButtons.filter(item => {
                // Rule 1: Hide "Specific Item A" if user is a man
                if (this.userAccount === 'individual' && item.name === 'Financial status') {
                    return false; 
                }

                // Rule 2: Hide "Specific Item B" if user is under 18
                // if (this.who_you === 'Tenant' && this.userAccount === 'individual' && item.name === 'Financial status') {
                //     return false;
                // }

                // Rule 3: Add more conditions as needed...
                // if (someOtherCondition) return false;

                // If no rules were triggered, keep the item
                return true;
            });
        }
    },
    // watch: {
    //     userObjectUrl(newVal, oldVal) {
    //     console.log('Name changed from', oldVal, 'to', newVal);
    //     this.getCityFromState();
    //         if (newVal) {
    //             this.getCityFromState();
    //         }
    //     }
    // },
    mounted() {
        this.user = JSON.parse(localStorage.getItem("shelta-user"));
        this.userAccount = JSON.parse(localStorage.getItem("shelta-user")).accounttype;
        this.who_you = localStorage.getItem("shelta-loger");
        this.fetchOccupationTypes();
        this.getUserProfile();
        this.fetchOrganization();
        document.addEventListener("click", this.handleClickOutside);
        this.fetchAssociations();
        
    },
    beforeDestroy() {
        // Remove the click event listener when the component is about to be destroyed
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        closeModalNow() {
            this.fileselected = "";
            this.fileToUpload = "";
            this.imagePreview = "";

        },
        modalClose() {
            $("#uploaddoc")
            .removeClass("fade")
            .modal("hide");
        },
        scrollToSection(id) {
            // const refName = "navMove-" + id;
            // this.theRef = id.toString()
            // const el = this.$refs[this.theRef];
            // console.log("check", this.theRef)
            // // const target = Array.isArray(el) ? el[0] : el;
            // if (el) {
            //     el.scrollIntoView({ behavior: "smooth" });
            // }
            this.$refs.mySection.scrollIntoView({ behavior: 'smooth' });
        },
        handleClickOutside(event) {
            const targetElement = this.$refs.orgg;
            if (!targetElement?.contains(event.target)) {
                // The click occurred outside the target element
                // Put your code here to handle clicks outside the element
                this.openOption = false;
            }
            },
            filterOrganization(string) {
            // console.log("Org", this.nameofOrganization);
            const regexp = new RegExp(string, "i");
            const filtered = this.organizations.filter(x => regexp.test(x.firstname));
            this.organizations = filtered;
            if (this.organizations.length == 0 || this.nameofOrganization === "") {
                this.fetchOrganization();
            }
            },
            runOption(event) {
            const inputBox = this.$refs.openPanel;
            this.openOption = true;
            if (!inputBox.contains(event.target)) {
                this.openOption = false;
            }
            },
            selectPanel(name, id, item) {
            this.nameofOrganization = name;
            this.handlerId = id;
            this.employAddress = item.address;
            this.employPhone = item.phone;
            this.openOption = false;
            this.disableInput = true;
            // this.fetchPartnerServices(id);
            },
            async fetchOrganization() {
            try {
                await Api.getRequest(`fetchorganisations`)
                .then(res => {
                    // console.log("Organization", res);
                    this.organizations = res.data.org;
                })
                .catch(err => {
                    console.log(err);
                });
            } finally {
                // conole.log("closed");
            }
        },
        getNavigationLabel(item) {
            // console.log("Iteemmmmmmm", item)
            if (this.userAccount === 'individual' && item == 'Biodata') return 'Biodata';
            if (this.userAccount === 'organization' && item == 'Biodata') return 'Profile';
            return item;
        },
        copyAccountNumber(value) {
            navigator.clipboard.writeText(value)
            .then(() => {
                this.$store.commit("setApiSuccess", `Copied ${value}`);
            })
            .catch(err => {
                console.error('Failed to copy: ', err)
            })
        },
        selectDocToUpload() {
            this.fileselected = this.$refs.doc.files[0];
            console.log("File type", this.fileselected);
            this.fileToUpload = this.fileselected.name;
            const reader = new FileReader();
            reader.onload = e => {
                this.imagePreview = e.target.result;
            };
            reader.readAsDataURL(this.fileselected);
        },
        async uploadMeansOfId(event) {
            this.uploading = true;
            if (this.meansType == '') {
                this.uploading = false;
                return this.$store.commit("setApiFailed", "Select document type");
            }
            if (!this.fileselected) {
                this.uploading = false;
                return this.$store.commit("setApiFailed", "Nothing was selected!");
            }
            if (
                this.fileselected.type === "image/jpeg" ||
                this.fileselected.type === "image/jpg" ||
                this.fileselected.type === "image/png" ||
                this.fileselected.type === "image/gif" ||
                this.fileselected.type === "application/pdf" ||
                this.fileselected.type === "svg+xml"
            ) {
                // this.loader2 = true;
                this.uploading = true;
            } else {
                // this.loader2 = false;
                this.uploading = false;
                this.$store.commit("setApiWarning", "");
                return this.$store.commit(
                "setApiFailed",
                "Please select a pdf or image file"
                );
            }
           
            const formData = new FormData();
            const sizeInMB = (this.fileselected.size / (1024 * 1024)).toFixed(3);
            this.fileSizeInMb = sizeInMB;
            formData.append("id", this.user.id);
            formData.append("file", this.fileselected);
            formData.append("documentType", this.meansType);
            if (sizeInMB > 5) {
                // this.fileSizeType = true;
                this.uploading = false;
                return this.$store.commit(
                "setApiFailed",
                "File size too large, should be more than 5MB"
                );
            } else {
                try {
                await Api.postRequest(`uploaduseridentity`, formData)
                    .then(res => {
                    this.$store.commit("setApiWarning", "");
                    // this.loader2 = false;
                    this.uploading = false;
                    if (res.data.error) {
                        // this.fileSizeType = true;
                        return this.$store.commit("setApiFailed", res.data.error);
                    } else if (res.data.success) {
                        this.uploading = false;
                        this.fileselected = "";
                        this.getUserProfile();
                        // this.evidenceofownership = res.data.url;
                        // this.eviownship = res.data.filename;
                        // this.evidenceofownership = res.data.filename;
                        this.$store.commit(
                        "setApiSuccess",
                        "Document uploaded successfuly"
                        );
                        $("#uploaddoc")
                        .removeClass("fade")
                        .modal("hide");
                        this.closeModalNow();
                    }
                    })
                    .catch(err => {
                    // this.loader2 = false;
                    this.uploading = false;
                    // console.log(err);
                    });
                } finally {
                // console.log("Closed connection");
                }
            }
        },
        fetchOccupationTypes() {
            Api.getRequest(`fetchoccupationtypes`).then(res => {
                // console.log("Occupation", res)
                this.occupationTypes = res.data.occupation;
            });
        },
        fetchAssociations() {
            Api.getRequest(`fetch-associations`).then(res => {
                this.associations = res.data.associations;
            });
        },
        
        async updateAssociation() {
            if (this.associationId === "") {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Select association!");
            }
            this.loader = true;
            try {
                await Api.postRequest(`update-user-association`, {
                    association_id: this.associationId,
                }).then(res => {
                    this.loader = false;
                    if (res.success) {
                        // console.log("Association updated", res)
                        this.getUserProfile();
                        return this.$store.commit("setApiSuccess", 'Success');
                    }
                    else if (res.data.error) {
                        this.loader = false;
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch(err => {
                    this.loader = false;
                    // console.log(err);
                });
            } finally {
                // console.log("closed")
            }
        },
        profileSetup() {
            // console.log('Hellow profile', this.dob);
            this.loader = true;
            this.errors = [];
            if (this.firstname === "") {
                this.errors.push("First name is required!");
                this.loader = false;
            }
            if (this.lastname === "") {
                this.errors.push("Last name is required!");
                this.loader = false;
            }
            else {
                Api.postRequest(`updateuser`, {
                id: JSON.parse(localStorage.getItem("shelta-user")).id,
                firstname: this.userObjectUrl.firstname,
                lastname: this.userObjectUrl.lastname,
                othernames: this.userObjectUrl.othernames,
                address: this.userObjectUrl.address,
                dob: this.userObjectUrl.dob,
                // countryid: this.userObjectUrl.countryid,
                countryid: 161,
                stateid: this.userObjectUrl.stateid,
                cityid: this.userObjectUrl.cityid,
                phone: this.userObjectUrl.phone,
                gender: this.userObjectUrl.gender
                }).then(res => {
                if (res.data.success) {
                    this.loader = false;
                    // console.log("success res", res);
                    localStorage.setItem("shelta-user", JSON.stringify(res.data.user));
                    this.getUserProfile();
                    // this.socialLinkSetup();
                    return this.$store.commit("setApiSuccess", 'Success');
                } else if (res.data.error) {
                    this.loader = false;
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                });
            }
        },
        selectProfileImage() {
            const file = this.$refs.cam.files[0];
            this.fileProfile = this.$refs.cam.files[0];
            this.fileName = this.$refs.cam.files[0].name;
            this.filePath = URL.createObjectURL(file);
            if (!this.fileProfile) {
                return this.$store.commit("setApiFailed", "Nothing was selected!");
            }
            if (
                this.fileProfile.type === "image/jpeg" ||
                this.fileProfile.type === "image/jpg" ||
                this.fileProfile.type === "image/png" ||
                this.fileProfile.type === "image/gif"
            ) {
                this.isUploadingPix = true;
            } else {
                this.isUploadingPix = false;
                return this.$store.commit(
                "setApiFailed",
                "Please select an image file"
                );
            }
            const formData = new FormData();
            const sizeInMB = (this.fileProfile.size / (1024 * 1024)).toFixed(3);
            this.fileSizeInMb = sizeInMB;
            // console.log("File Size", sizeInMB);
            // console.log("form data", formData);
            formData.append("id", this.user.id);
            formData.append("file", this.fileProfile);

            this.isUploadingPix = true;
            if (sizeInMB > 5) {
                this.fileSizeType = true;
                this.isUploadingPix = false;
                return this.$store.commit(
                "setApiFailed",
                "File size too large, should be less than 5MB"
                );
            } else {
                Api.postRequest(`uploaduserphoto`, formData)
                .then(res => {
                    // console.log("File upload", res);
                    this.isUploadingPix = false;
                    if (res.data.error) {
                    // console.log("error while uploading:");
                    // this.fileSizeType = true;
                    return this.$store.commit("setApiFailed", res.data.error);
                    } else {
                    this.filePath = res.data.url;
                    this.getUserProfile();
                    // this.fileSizeType = true;
                    this.$store.commit("setApiSuccess", "profile picture updated");
                    }
                })
                .catch(err => {
                    this.isUploadingPix = false;
                    console.log(err);
                });
            }
        },
        getUserProfile() {
            this.pageLoader = true;
            Api.getRequest(`getuserbyid/${this.user.id}`).then(res => {
                // console.log("profile", res);
                this.pageLoader = false;
                if (res.status == 401) {
                window.localStorage.clear();
                return (window.location.href = "https://myshelta.com/login");
                }
                this.fullObjectUser = res.data.fulldata;
                this.userObjectUrl = res.data.user;
                this.fetchCountries();
                // this.user.countryid = this.countryId;
                // this.stateId = this.user.stateid;
                // this.cityId = this.user.cityid;
                this.fulldata = res.data.fulldata;
                this.emergency = this.fulldata.emergency_details;

                if (this.fulldata.nextofkin != null) {
                this.fullnamenok = this.fulldata.nextofkin.fullname;
                this.phonenok = this.fulldata.nextofkin.phone;
                this.emailnok = this.fulldata.nextofkin.email;
                this.addressnok = this.fulldata.nextofkin.address;
                this.relationshipnok = this.fulldata.nextofkin.relationship;
                }

                if (this.fulldata.user_object.meansofidtype != null) {
                this.modeOfIdSelected = this.fulldata.user_object.meansofidtype;
                }

                if (this.fulldata.user_object.occupationid != null) {
                const myOccupation = this.occupationTypes.find(
                    x => x.id == this.fulldata.user_object.occupationid
                );
                this.emplymentStatus = myOccupation.occupation;
                if (this.emplymentStatus == null) {
                    this.getUserProfile();
                }
                if (this.fulldata.realtorcode != null) {
                    this.referrer = this.fulldata.realtorcode;
                }
                // this.employmentStatusFunc(this.emplymentStatus);
                if (this.fulldata.employeddetails != null) {
                    this.employAddress = this.fulldata.employeddetails.address;
                    this.nameofOrganization = this.fulldata.employeddetails.nameoforganisation;
                    this.jobTitle = this.fulldata.employeddetails.jobtitle;
                    this.dateofEmployment = this.fulldata.employeddetails.dateofemployment;
                    this.employPhone = this.fulldata.employeddetails.phone;
                }
                if (this.fulldata.selfemployed_details != null) {
                    this.businessAddress = this.fulldata.selfemployed_details.businessaddress;
                    this.nameOfBusiness = this.fulldata.selfemployed_details.nameofbusiness;
                    this.typeOfBusiness = this.fulldata.selfemployed_details.typeofbusiness;
                    this.businessSector = this.fulldata.selfemployed_details.businesssector;
                    this.certificateOfIncoporation = this.fulldata.selfemployed_details.certificateofincoporation;
                    if (this.fulldata.selfemployed_details.isregistered == "0") {
                    this.isRegistered = "0";
                    } else {
                    this.isRegistered = "1";
                    this.businessRegType = this.fulldata.selfemployed_details.registrationtype;
                    this.registrationNumber = this.fulldata.selfemployed_details.regnumber;
                    const registeredBiz = document.getElementById(
                        "registeredBusiness"
                    );
                    if (this.isRegistered === "1") {
                        registeredBiz.style.display = "block";
                        if (this.businessRegType === "Limited Liability Company") {
                        this.checkBizType = true;
                        } else {
                        this.checkBizType = false;
                        }
                    } else {
                        this.isRegistered === "0";
                        registeredBiz.style.display = "none";
                        //  this.businessRegType = "";
                    }
                    }
                    // this.employPhone = this.fulldata.selfemployed_details.phone;
                }
                if (this.fulldata.unemployed != null) {
                    this.unemployedAddress = this.fulldata.unemployed.address;
                    this.lastWorkPlace = this.fulldata.unemployed.lastworkplace;
                    this.currentSourceOfIncome = this.fulldata.unemployed.currentsourceofincome;
                    this.unemployedPhone = this.fulldata.unemployed.phone;
                    this.dateOfDisengagement = this.fulldata.unemployed.dateofdisengagement;
                }
                }

                if (this.fulldata.financial_status != null) {
                    this.incomeSelected = this.fulldata.financial_status;
                }

                if (this.fulldata.gurantor != null) {
                    this.fullnameg = this.fulldata.gurantor.fullname;
                    this.emailg = this.fulldata.gurantor.email;
                    this.phoneg = this.fulldata.gurantor.phone;
                    this.addressg = this.fulldata.gurantor.address;
                    this.relationshipg = this.fulldata.gurantor.relationship;
                }

                if (this.fulldata.emergency_details != null) {
                    this.fullnameem = this.fulldata.emergency_details.fullname;
                    this.emailem = this.fulldata.emergency_details.email;
                    this.phoneem = this.fulldata.emergency_details.phone;
                    this.addressem = this.fulldata.emergency_details.address;
                    this.relationshipem = this.fulldata.emergency_details.relationship;
                }

                this.city = res.data.user.cityObject;
                this.state = res.data.user.stateObject;
                this.country = res.data.user.countryObject;
                this.associationId = res.data.user.association_id;
                // console.log('codeeees', this.city, this.state);
                localStorage.setItem("shelta-user", JSON.stringify(res.data.user));
            });
        },
        async updateNextofKin() {
            try {
                this.loader = true;  
                await Api.postRequest(`updatenextofkin`, {
                    id: JSON.parse(localStorage.getItem("shelta-user")).id,
                    fullname: this.fullObjectUser.nextofkin.fullname,
                    email: this.fullObjectUser.nextofkin.email,
                    phone: this.fullObjectUser.nextofkin.phone,
                    address: this.fullObjectUser.nextofkin.address,
                    relationship: this.fullObjectUser.nextofkin.relationship,
                    }).then(res => {
                    this.loaderN = false;
                    console.log(res);
                    if (res.data.success) {
                        this.loader = false;
                        this.getUserProfile();
                        return this.$store.commit("setApiSuccess", res.data.success);
                    } else if (res.data.error) {
                        this.loader = false;
                        // console.log("Error");
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                });
            } finally {
                // console.log("closed")
            }
        },
        async updateEmergencyContact() {
            this.loader = true;
            if (this.fullnameem === null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Full name is required!");
            }
            if (this.emailem === null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Email is required!");
            }
            if (this.phoneem === null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Phone number is required!");
            }
            if (this.addressem === null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Address is required!");
            }
            if (this.relationshipem === null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Relationship is required!");
            }
            else {
                try {
                await Api.postRequest(`editemergency`, {
                    userId: JSON.parse(localStorage.getItem("shelta-user")).id,
                    fullname: this.fullnameem,
                    email: this.emailem,
                    phone: this.phoneem,
                    address: this.addressem,
                    relationship: this.relationshipem,
                })
                    .then(res => {
                        this.loader = false;
                        if (res.data.success) {
                            this.getUserProfile();
                            return this.$store.commit("setApiSuccess", res.data.success);
                        } 
                        if (res.data.error) {
                            return this.$store.commit("setApiFailed", res.data.error);
                        }
                    })
                    .catch(err => {
                    this.loader1 = false;
                    console.log(err);
                    });
                } finally {
                // console.log("Closed connection");
                }
            }
        },

        async updateGuarantor() {
            this.loader = true;
            if (this.fullnameg === null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Full name is required!");
            }
            if (this.phoneg === null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Phone number is required!");
            }
            if (this.emailg === null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Email is required!");
            }
            if (this.addressg === null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Address is required!");
            }
            if (this.relationshipg === null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Relationship is required!");
            }
            else {
                try {
                await Api.postRequest(`editgurantor`, {
                    userId: JSON.parse(localStorage.getItem("shelta-user")).id,
                    fullname: this.fullnameg,
                    email: this.emailg,
                    phone: this.phoneg,
                    address: this.addressg,
                    relationship: this.relationshipg,
                    // passportfile: this.passportfileg
                })
                    .then(res => {
                    if (res.data.success) {
                        this.loader = false;
                        // console.log("success res", res);
                        this.getUserProfile();
                        return this.$store.commit("setApiSuccess", res.data.success);
                    }
                    if (res.data.error) {
                        this.loader = false;
                        // console.log("Error");
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                    })
                    .catch(err => {
                        this.loader = false;
                        console.log(err);
                    });
                } finally {
                // console.log("Closed connection");
                }
            }
        },

        occupationUpdatingOption() {
            if (this.userObjectUrl.occupationid == '1' || this.userObjectUrl.occupationid == '2' || this.userObjectUrl.occupationid == '3') {
                this.updateOccupationEnterpreneur();
            }
            if (this.userObjectUrl.occupationid == '4' || this.userObjectUrl.occupationid == '6') {
                this.updateOccupationUnemployed();
            }
            if (this.userObjectUrl.occupationid == '5' || this.userObjectUrl.occupationid == '7') {
                this.updateOccupationEmployed();
            }
        },

        async updateOccupationEnterpreneur() {
        
            if (this.nameOfBusiness == '') {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Name of business is required");
            }
            if (this.typeOfBusiness == '') {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Type of business is required");
            }
            if (this.businessSector == "") {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Business sector is required");
            }
            if (this.businessAddress == '') {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Business address is required");
            }

            if (this.isRegistered == "" || this.isRegistered == null) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Is bussiness registered is required");
            }
            if (this.isRegistered == "1" && (this.isRegistered != "" || this.isRegistered != null)) {
                if (this.certificateOfIncoporation == null || this.certificateOfIncoporation == '') {
                    this.loader = false;
                    return this.$store.commit("setApiFailed", "Certicate of incoporation name is required");
                }
                if (this.registrationNumber == null || this.registrationNumber == "") {
                    this.loader = false;
                    return this.$store.commit("setApiFailed", "Registration number is required");
                }
            }
            this.loader = true;
            try {
            await Api.postRequest(`edituserselfemployeddetails`, {
                userid: JSON.parse(localStorage.getItem("shelta-user")).id,
                nameofbusiness: this.nameOfBusiness,
                typeofbusiness: this.typeOfBusiness,
                businesssector: this.businessSector,
                businessaddress: this.businessAddress,
                isregistered: this.isRegistered,
                regnumber: this.registrationNumber,
                registrationtype: this.businessRegType,
                // certificateofincoporation: this.coi,
                // formco2: this.formCo,
                // Check this one
                occupationid: this.userObjectUrl.occupationid,
                // occupationid: this.occupationId
            })
                .then(res => {
                // console.log("self employed ccupation", res);
                this.loader = false;
                if (res.data.success) {
                    this.getUserProfile();
                    return this.$store.commit("setApiSuccess", res.data.success);
                } else if (res.data.error) {
                    // console.log("Error");
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                })
                .catch(err => {
                  this.loader = false;
                console.log(err);
                });
            } finally {
            // console.log("Connection closed");
            }
        },

        async updateOccupationUnemployed() {
        
            if (this.lastWorkPlace == '') {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Last place of work is required");
            }
            if (this.currentSourceOfIncome == '') {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Current source of income is required");
            }
            if (this.unemployedPhone == '') {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Phone is required");
            }
            if (this.unemployedAddress == '') {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Address is required");
            }

            if (this.dateOfDisengagement == '') {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Date of disengament is required");
            }
            this.loader = true;
            try {
            await Api.postRequest(`edituserunemloyeddetails`, {
                userid: JSON.parse(localStorage.getItem("shelta-user")).id,
                lastworkplace: this.lastWorkPlace,
                dateofdisengagement: this.dateOfDisengagement,
                currentsourceofincome: this.currentSourceOfIncome,
                address: this.unemployedAddress,
                phone: this.unemployedPhone,
                occupationid: this.userObjectUrl.occupationid,
            })
                .then(res => {
                // console.log("self employed ccupation", res);
                this.loader = false;
                if (res.data.success) {
                    this.getUserProfile();
                    return this.$store.commit("setApiSuccess", res.data.success);
                } else if (res.data.error) {
                    // console.log("Error");
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                })
                .catch(err => {
                this.loader = false;
                console.log(err);
                });
            } finally {
            // console.log("Connection closed");
            }
        },


        updateOccupationEmployed: async function() {
            this.loader = true;
            if (this.nameofOrganization == "") {;
            this.loader = false;
            return this.$store.commit("setApiFailed", "Name of Organization is required");
            }
            if (this.dateofEmployment == "") {
            this.loader = false;
            return this.$store.commit("setApiFailed", "Date of employment is required");
            }
            if (this.jobTitle == "") {
            this.loader = false;
            return this.$store.commit("setApiFailed", "Job Title is required");
            }
            if (this.employAddress == "") {
            this.loader = false;
            return this.$store.commit("setApiFailed", "Office address is required");
            }
            if (this.employPhone == "") {
            this.loader = false;
            return this.$store.commit("setApiFailed", "mployers's phone number is required");
            }
        
            try {
                await Api.postRequest(`edituseremployedetails`, {
                    userid: JSON.parse(localStorage.getItem("shelta-user")).id,
                    nameoforganisation: this.nameofOrganization,
                    dateofemployment: this.dateofEmployment,
                    jobtitle: this.jobTitle,
                    phone: this.employPhone,
                    address: this.employAddress,
                    occupationid: this.userObjectUrl.occupationid,
                    // occupationid: this.occupationId
                })
                .then(res => {
                // console.log("Employed ccupation", res);
                this.loader = false;
                if (res.data.success) {
                    this.getUserProfile();
                    return this.$store.commit("setApiSuccess", res.data.success);
                } else if (res.data.error) {
                    // console.log("Error");
                    this.loader = false;
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                })
                .catch(err => {
                this.loader = false;
                console.log(err);
                });
            } finally {
            // console.log("Connection closed");
            }
        },

        employmentStatusFunc: async function(event) {
            this.emplymentStatus = event;
            const employmentSelect = document.getElementsByClassName(
                "occupation-holder"
            );
            employmentSelect[0].style.paddingBottom = "0rem";
            const employedDiv = document.getElementById("employed");
            const employedDiv2 = document.getElementById("unemployed");
            const employedDiv3 = document.getElementById("enterpreneur");
            if (this.emplymentStatus === "employed") {
                const employedDiv = document.getElementById("Employed");
                employedDiv.style.display = "block";
                employedDiv2.style.display = "none";
                employedDiv3.style.display = "none";
            } else if (
                this.emplymentStatus === "Unemployed" ||
                this.emplymentStatus === "Retired"
            ) {
                const employedDiv2 = document.getElementById("unemployed");
                employedDiv2.style.display = "block";
                employedDiv.style.display = "none";
                employedDiv3.style.display = "none";
            } else if (
                this.emplymentStatus === "Enterpreneur" ||
                this.emplymentStatus === "Self Employed" ||
                this.emplymentStatus === "Business"
            ) {
                const employedDiv3 = document.getElementById("enterpreneur");
                employedDiv3.style.display = "block";
                employedDiv2.style.display = "none";
                employedDiv.style.display = "none";
            } else if (
                this.emplymentStatus === "Employed" ||
                this.emplymentStatus === "NGO"
            ) {
                employedDiv3.style.display = "none";
                employedDiv2.style.display = "none";
                employedDiv.style.display = "block";
            } else {
                employedDiv3.style.display = "none";
                employedDiv2.style.display = "none";
                employedDiv.style.display = "none";
                this.emplymentStatus = "";
            }
            const y = this.occupationTypes.filter(element => {
                if (element.occupation === this.emplymentStatus) {
                return (this.occupationId = element.id);
                }
            });
        },
        async fetchCountries() {
            try {
                await Api.getRequest(`fetchallcountries`)
                .then(res => {
                    // this.$store.commit("setApiWarning", "Loading countries...");
                    // console.log(res);
                    if (res.data.success) {
                    this.getCountries = res.data.countries;

                    this.getStatesFromCountry();
                    // this.$store.commit("setApiSuccess", "Countries loaded");
                    // this.$store.commit("setApiWarning", "");
                    } else if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            } finally {
                // console.log("closed")
            }
        },
        async getStatesFromCountry() {
            // console.log("country id", this.user.countryid);
            try {
                await Api.getRequest(`fetchstatesbycountryid/${161}`)
                // await Api.getRequest(`fetchstatesbycountryid/${this.countryId}`)
                // await Api.getRequest(`fetchstatesbycountryid/${this.user.countryid}`)
                .then(res => {
                    this.$store.commit("setApiWarning", "Loading states...");
                    if (res.data.success) {
                    this.getstates = res.data.states;
                    this.stateID = this.user.stateid;
                    // this.getStateId(this.stateID);
                    this.getCityFromState();
                    this.$store.commit("setApiSuccess", "States loaded");
                    this.$store.commit("setApiWarning", "");
                    } else if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            } finally {
                // console.log("Finanlly");
            }
        },
        getCityFromState() {
           this.cityloading = true;
            Api.getRequest(`fetchcitiesbystateid/${this.stateID}`)
                .then(res => {
                this.$store.commit("setApiWarning", "Loading cities...");
                this.cityloading = false;
                if (res.data.success) {
                    this.getcities = res.data.cities;
                    // this.$store.commit("setApiSuccess", "States loaded");
                    this.$store.commit("setApiWarning", "");
                } else if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
            })
                .catch(err => {
                console.log(err);
                this.cityloading = false;
            });
        },
        getcitiesbystateid(event) {
            this.stateID = event.target.value;
            this.cityid = this.event;
            this.getCityFromState();
            // this.getStatesFromCountry();
        },
        getIncomeValue: function(event) {
            this.incomeType = event.target.value;
        },
        monthlyIncome: function() {
            this.loader = true;
            if (!this.incomeType) {
                this.loader = false;
                return this.$store.commit("setApiFailed", "Select income range!");
            } else {
                Api.postRequest(`submitfinancialstatus`, {
                id: JSON.parse(localStorage.getItem("shelta-user")).id,
                averageincome: this.incomeType
                })
                .then(res => {
                    // console.log("Income added", res);
                    this.loader = false;
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", "An error occured");
                    } else {
                        this.getUserProfile(this.id);
                        this.$store.commit("setApiSuccess", "success");
                    }
                })
                .catch(err => {
                    this.loader = false;
                    console.log(err);
                });
            }
        },
        verifyNin() {
            this.loader = true;
            try {
                Api.postRequest('fetch-nin-details', {
                    nin: this.nin
                }).then(res => {
                    this.loader = false;
                    console.log("NIN Response:", res);
                }).catch(err => {
                    this.loader = false;
                    console.log(err);
                })
            } finally {
                // console.log("closed")
            }
        }
    },
    filters: {
        moment: function(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        },
        moment2: function(date) {
            return moment(date).format("MMMM Do YYYY");
        },
        moment3: function(date) {
            return moment(date).format("h:mm:ss a");
        },
    }
}
</script>


<style lang="scss" scoped>
$primary: #0033ea;
$secondary: #ffffff;
$yellow: #ffb100;
$tatiary: #a2b0e3;

.button-navigation {
    display: flex;
    white-space: nowrap;
    // overflow: scroll;
    margin: 20px 0;
    background: #fff;
    padding: 10px;
    border-radius: 5px 5px 0 0;
    button {
        font-family: Lato;
        font-weight: 700;
        font-style: Bold;
        font-size: 14px;
        color: #4B5563;
        outline: 0;
        box-shadow: none;
    }
}
.active-navigation {
    border-bottom: 2px solid #0033EA;
    border-radius: 0;
}

.white-bg {
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #E5E7EB;
    box-shadow: 0px 1px 2px 0px #1018280D;
    padding: 24px 20px;
}

.prifile-pix {
    position: relative;
    margin: auto;
    width: 156px;
    height: 156px;
    border-radius: 28px;
    border: 1px solid #E5E7EB;
    box-shadow: 0px 1px 2px 0px #1018280D;
    img {
        border-radius: 28px;
        // width: 156px;
        // height: 156px;
        height: 100%;
        width: 100%;
        object-fit: cover;
        overflow: hidden;
        display: block;
        margin: auto;
    }

}

.camera-icon {
    position: absolute;
    bottom: 20px;
    right: -28px;
    border: 1px solid #E5E7EB;
    background: #ffffff;
    border-radius: 50px;
    padding: 6px;
    cursor: pointer;
}

.profile-details {
    h5, h6 {
        font-family: Lato;
        font-size: 16px;
        line-height: 28px;
        text-align: left;
        margin-bottom: 0;
    }
    h5 {
        color: #374151;
        font-weight: 700;
        font-style: Bold;
    }
    h6 {
        color: #6B7280;
        font-weight: 400;
        display: flex;
        justify-content: space-between;
        span {
            cursor: pointer;
        }
    }
}

.bottom-profile {
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 12px;
        line-height: 30px;
        color: #000000;
        text-align: right;
    }
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 11px;
        line-height: 5px;
        color: #1D4B4E;
        text-align: left;
    }
    p {
        font-family: Lato;
        font-weight: 700;
        line-height: 30px;
        font-size: 11px;
        color: #1D4B4E;
        text-align: left;
    }
}

.top-headings {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 30px;
}

.update-status {
    font-family: Lato;
    font-weight: 700;
    font-size: 14px;
    line-height: 30px;
    color: #000000;
    text-align: left;
}

.verified-text {
    font-family: Lato;
    font-weight: 400;
    font-size: 10px;
    line-height: 30px;
    color: #1FC16B;
}

.upload-area {
    border: 2px dashed #DBDCDD;
    border-radius: 10px;
    background: #f6f6f6;
    padding: 30px;
    min-height: 232px;
    cursor: pointer;
    z-index: 100;
    h3 {
        font-family: Lato;
        font-weight: 700;
        font-size: 17px;
        line-height: 23px;
        text-align: center;
        color: #333333;
        margin-top: 20px
    }
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 14px;
        text-align: center;
        color: #333333;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 10px;
        line-height: 20px;
        color: #DFA052;
    }
    iframe, img {
        z-index: 50;
        cursor: pointer;
    }
}

.occupation-holder {
  padding-bottom: 3rem;
} 


// @keyframes spinBorder {
//   0% {
//     transform: rotate(0deg);
//   }
//   100% {
//     transform: rotate(360deg);
//   }
// }

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.prifile-pix.loading::before {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
//   width: 156px;
//   height: 156px;
  border-radius: 28px;
  width: calc(100% + 8px);
  height: calc(100% + 8px);
//   border-radius: 50%;
  border: 4px solid transparent;
  border-top: 4px solid #42b983;     /* Color 1 */
  border-right: 4px solid #3498db;   /* Color 2 */
  animation: spin 1s linear infinite;
  z-index: 1;
}


// DROPDOWN SELECT OR ADD STARTS
.panel-input {
  position: relative;
  input {
    padding-right: 30px;
    background: #ffffff;
    height: 44px;
    border: 0.5px solid #cecece;
    // border: 0.5px solid #a2b0e3;
    box-sizing: border-box;
    box-shadow: none;
    border-radius: 0px;
  }
  span {
    position: absolute;
    right: 15px;
    top: 43px;
    cursor: pointer;
    i {
      font-size: 11px;
    }
  }
}
.option-list {
  border: 0.7px solid #e5e5e5;
  border-top: 0;
  max-height: 85px;
  overflow: scroll;
  li {
    font-family: Lato;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    color: rgba(0, 0, 0, 0.5);
    list-style-type: none;
    cursor: pointer;
    text-align: left;
    padding: 0 15px;
  }
  li:hover {
    background: $primary;
    color: $secondary;
  }
  li:nth-child(even) {
  }
  li:nth-child(odd) {
  }
}
.handler-list {
  max-height: 150px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.activeHandler {
  background: $primary !important;
  color: $secondary !important;
}
.handler-list::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
// DROPDOWN SELECT OR ADD ENDS

// .uploading-border {
//   border: 4px solid #ccc;
//   border-top: 4px solid #42b983; /* green top border */
//   border-radius: 50%;
//   animation: spin 1s linear infinite;
// }

@media only screen and (max-width: 599px) {
    .button-navigation {
        position: fixed;
        z-index: 100;
        /* margin-bottom: 15rem; */
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
        margin-top: 0;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        width: 100%;
    }
    .profile-body-holder {
        padding-top: 4.5rem;
        margin-top: 0 !important
    }
}
</style>